module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 2H4c0-1.106-.894-2-2-2S0 .894 0 2v29a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-9h10v2c0 1.106.894 2 2 2h14c1.106 0 2-.894 2-2V8c0-1.106-.894-2-2-2H18V4c0-1.106-.894-2-2-2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/flag-3.js
// module id = 1149
// module chunks = 14